<template>
    <div class="basic_wrap">
        <!-- 顶部标题栏 -->
        <div class="interest_income_header">
            <div class="back_left" @click="$router.go(-1)">
                <img src="../../../src/assets/images/return.png" alt="返回">
            </div>
            <div class="big_tit">{{ $t('item.ProjectOrder') }}</div>
        </div>

        <!-- 主要内容区域 -->
        <div class="main_content">
            <!-- 表格头部 -->
            <div class="table_header">
                <div class="header_item">{{ $t('item.Project') }}</div>
                <div class="header_item">{{ $t('item.Amount/Income') }}</div>
                <div class="header_item">{{ $t('item.Time') }}</div>
                <div class="header_item">{{ $t('item.Status') }}</div>
            </div>

            <!-- 记录列表区域 -->
            <div class="records_container">
                <!-- 调试信息 - 开发时可开启 -->
                <!-- <div class="debug_info" v-if="false" style="padding: 10px; background: #f0f0f0; margin: 10px; font-size: 12px; border: 2px solid red;">
                    <p><strong>🔍 调试信息:</strong></p>
                    <p>loading状态: <span style="color: red;">{{ loading }}</span></p>
                    <p>记录数量: <span style="color: blue;">{{ interestRecords ? interestRecords.length : '未定义' }}</span></p>
                    <p>第一条记录: <span style="color: green;">{{ interestRecords && interestRecords.length > 0 ? JSON.stringify(interestRecords[0]).substring(0, 100) + '...' : '无数据' }}</span></p>
                </div> -->

                <!-- 加载状态 -->
                <div v-if="loading" class="loading_state">
                    <p>正在加载利息收益记录...</p>
                </div>

                <!-- 空状态 -->
                <div v-else-if="!interestRecords || interestRecords.length === 0" class="empty_state">
                    <p>暂无利息收益记录</p>
                </div>

                <!-- 记录列表 -->
                <div v-else class="records_list">
                    <div v-for="(record, index) in interestRecords" :key="index" class="record_item">
                        <div class="record_project">
                            <div class="project_name">{{ record.project_name }}</div>
                            <div class="project_details">
                                ({{ record.day }}{{ record.unit === 'hours' ? $t('item.xiaoshi') : $t('item.tian') }}) 
                                ({{ record.rate }}%) 
                                ({{ record.total_records }})
                            </div>
                        </div>
                        <div class="record_amount">
                            <div class="amount_text">
                                <div class="amount_label">{{ $t('item.zongbenjin') }}:</div>
                                <div class="amount_value">${{ formatMoney(record.total_money) }}</div>
                            </div>
                            <div class="income_text">
                                <div class="income_label">{{ $t('item.zongshouyu') }}:</div>
                                <div class="income_value">${{ formatMoney(record.total_interest) }}</div>
                            </div>
                        </div>

                        <div class="record_time">
                            <div class="time_label">{{ $t('item.zhuanrushijian') }}:</div>
                            <div class="time_value">{{ formatTime(record.earliest_time) }}</div>
                            <div class="time_label">{{ $t('item.jiesuanshijian') }}:</div>
                            <div class="time_value">{{ formatTime(record.latest_time) }}</div>
                        </div>
                        <div class="record_status">
                            <span :class="getProjectStatusClass(record.status)">
                                {{ getProjectStatusText(record.status) }}
                            </span>
                            <div class="status_details">
                                <div>{{ $t('item.yijiesuan') }}: {{ record.completed_records }}/{{ record.total_records }}</div>
                                <div>{{ $t('item.daijiesuan') }}: {{ record.pending_records }}/{{ record.total_records }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部导航栏 -->
        <FooterTab :activeType="'user'" />
    </div>
</template>

<script>
import FooterTab from '../../components/FooterTab.vue'
import Fetch from '../../utils/fetch'

export default {
    name: "InterestIncome",
    components: { FooterTab },
    data() {
        return {
            show_icon_type: 'user',
            interestRecords: [], // 存储利息收成记录数据
            loading: false, // 加载状态
            lang: (this.$i18n.locale || "zh_CN").toLowerCase().replace('-', '_') // 当前语言
        };
    },
    created() {
        this.$parent.footer("user", false);
        this.show_icon_type = 'user';
        this.getInterestRecords();
    },
    methods: {
        // 获取利息收成记录
        // 获取利息收成记录（使用 invest_time 作為最早時間來源）
        async getInterestRecords() {
        try {
            this.loading = true;
            const result = await Fetch('/user/order');

            if (result && result.code === 1) {
            let records = [];
            if (Array.isArray(result.data)) {
                records = result.data;
            } else if (result.data && Array.isArray(result.data.list)) {
                records = result.data.list;
            } else {
                records = [];
            }

            const processedRecords = records.map(item => {
                const langName = item[this.lang];
                return {
                ...item,
                // 合併鍵
                project_id: item.pid ?? item.project_id ?? 0,
                project_name: langName ?? item.zh_cn ?? item.project_name ?? '项目名称',

                // 金額：money2=本金、money1=收益
                money: Number(item.money2 ?? item.money ?? 0),
                interest: Number(item.money1 ?? item.interest ?? 0),

                // 時間欄位：最早用 invest_time；最新用 time2
                invest_time: item.invest_time ?? '',                 // 👈 新增，作為 earliest_time 來源
                time:        item.time1 ?? item.time ?? item.add_time ?? '', // 保留（若要用得到）
                time2:       item.time2 ?? item.end_time ?? '',

                // 其他
                status: Number(item.status ?? 0),
                day: Number(item.day ?? 1),
                unit: item.unit ?? 'day',
                rate: Number(item.rate ?? 0),
                };
            });

            this.interestRecords = this.mergeProjectRecords(processedRecords);
            } else if (result && result.code === 0) {
            this.interestRecords = [];
            } else {
            this.interestRecords = [];
            }
        } catch (e) {
            console.error('💥 获取利息收益记录出错:', e);
            this.interestRecords = [];
        } finally {
            this.loading = false;
        }
        },
        mergeProjectRecords(records) {
  const projectMap = new Map();

  records.forEach(record => {
    const projectKey = `${record.project_id}_${record.project_name}`;
    if (!projectMap.has(projectKey)) {
      projectMap.set(projectKey, {
        project_id: record.project_id,
        project_name: record.project_name,
        day: record.day,
        unit: record.unit,
        rate: record.rate,
        total_money: 0,
        total_interest: 0,
        completed_money: 0,
        completed_interest: 0,
        pending_money: 0,
        pending_interest: 0,
        total_records: 0,
        completed_records: 0,
        pending_records: 0,
        earliest_time: '',   // 之後用 invest_time 決定
        latest_time: '',     // 之後用 time2 決定
        status: 1,           // 先假設完成；只要遇到未完成改為 0
        _times: []           // 暫存 (status, invest_time, time2)
      });
    }

    const p = projectMap.get(projectKey);
    const st = Number(record.status);

    const money = Number(record.money || 0);
    const interest = Number(record.interest || 0);
    p.total_money += money;
    p.total_interest += interest;
    p.total_records += 1;

    if (st === 1) {
      p.completed_money += money;
      p.completed_interest += interest;
      p.completed_records += 1;
    } else {
      p.pending_money += money;
      p.pending_interest += interest;
      p.pending_records += 1;
      p.status = 0;
    }

    // 暫存時間（用 invest_time 作 earliest 候選；time2 作 latest 候選）
    p._times.push({
      status: st,
      invest_time: record.invest_time || (record.time ?? ''), // 若後端缺 invest_time，可退回 time1/time
      time2: record.time2 || ''
    });
  });

  // 決定 earliest/latest：有未完成→只看 status=0；全完成→看全部
  const merged = Array.from(projectMap.values()).map(p => {
    const pool = p.pending_records > 0 ? p._times.filter(t => t.status === 0) : p._times;

    let earliest = '';
    let latest = '';
    for (const t of pool) {
      if (t.invest_time && (!earliest || t.invest_time < earliest)) earliest = t.invest_time;
      if (t.time2       && (!latest   || t.time2       > latest))   latest   = t.time2;
    }

    delete p._times;
    return { ...p, earliest_time: earliest, latest_time: latest };
  });

  // 排序：進行中在前；同狀態按 latest_time 倒序（字串比較最穩）
  merged.sort((a, b) => {
    if (a.status !== b.status) return a.status - b.status;
    return (b.latest_time || '').localeCompare(a.latest_time || '');
  });

  return merged;
},        
        // 格式化时间显示
        formatTime(timeStr) {
            if (!timeStr || timeStr === '暂无时间' || timeStr === '0000-00-00 00:00:00') {
                return '--';
            }
            
            try {
                // 格式化为 MM-DD HH:mm
                const date = new Date(timeStr);
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                
                return `${month}-${day} ${hours}:${minutes}`;
            } catch (error) {
                console.error('时间格式化错误:', error);
                return timeStr;
            }
        },
        
        // 格式化金额显示
        formatMoney(amount) {
            return parseFloat(amount).toFixed(2);
        },
        
        // 获取项目状态文本
        getProjectStatusText(status) {
            return status === 1 ? this.$t('item.yiwancheng') : this.$t('item.jingxingzhong');
        },
        
        // 获取项目状态样式类
        getProjectStatusClass(status) {
            return status === 1 ? 'status_completed' : 'status_pending';
        }
    }
};
</script>

<style lang="less" scoped>
.basic_wrap {
    // min-height: 100vh;
    background: #ffffff;
    display: flex;
    flex-direction: column;
}

.interest_income_header {
    position: relative;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    color: #000000;
    border-bottom: 1px solid #f0f0f0;

    .back_left {
        position: absolute;
        left: 15px;
        top: 0;
        bottom: 0;
        cursor: pointer;
        background: none;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 16px;
            height: 16px;
        }
    }

    .big_tit {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.main_content {
    flex: 1;
    background: #ffffff;
}

.table_header {
    display: flex;
    padding: 12px 0;

    .header_item {
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #495057;
        padding: 0 8px;
    }
}

.records_container {
    flex: 1;
    min-height: 400px;
    background: #ffffff;
}

.loading_state, .empty_state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: #999;
    font-size: 14px;
}

.records_list {
    padding: 0;
}

.record_item {
    display: flex;
    align-items: center;
    padding: 20px 15px;
    border-bottom: 1px solid #f0f0f0;
    background: #ffffff;
    
    &:last-child {
        border-bottom: none;
    }
}

.record_project {
    flex: 1.2;
    text-align: left;
    
    .project_name {
        font-size: 15px;
        color: #333;
        font-weight: 500;
        margin-bottom: 4px;
        line-height: 1.2;
    }
    
    .project_details {
        font-size: 12px;
        color: #666;
        line-height: 1.2;
    }
}

.record_amount {
    flex: 1.2;
    text-align: center;
    
    .amount_text, .income_text {
        margin-bottom: 8px;
        
        .amount_label, .income_label {
            font-size: 11px;
            color: #666;
            margin-bottom: 2px;
        }
        
        .amount_value, .income_value {
            font-size: 14px;
            color: #333;
            font-weight: 600;
        }
    }
    
    .amount_text {
        .amount_value {
            color: #1890ff;
        }
    }
    
    .income_text {
        .income_value {
            color: #52c41a;
        }
    }
}

.record_time {
    flex: 1.2;
    text-align: center;
    
    .time_label {
        font-size: 11px;
        color: #666;
        margin-bottom: 2px;
    }
    
    .time_value {
        font-size: 12px;
        color: #333;
        margin-bottom: 6px;
        font-weight: 500;
    }
}

.record_status {
    flex: 1;
    text-align: center;
    
    .status_completed, .status_pending {
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 6px;
        display: block;
    }
    
    .status_completed {
        color: #52c41a;
    }
    
    .status_pending {
        color: #ff9500;
    }
    
    .status_details {
        font-size: 10px;
        color: #666;
        line-height: 1.3;
        
        div {
            margin-bottom: 2px;
        }
    }
}

/* 底部导航栏样式 */
.footer {
    position: fixed;
    margin: 0 auto;
    left: 0;
    right: 0;
    flex: 0 0 48px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 750px;
    bottom: 0;
    height: 60px;
    z-index: 4;
}

.footer .footer_item {
    display: flex;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    color: #55585a;
    width: 60px;
}

.footer .footer_item .footer_icon {
    display: inline-block;
    width: 26px;
    height: 26px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin-bottom: 6px;
}

.footer .footer_item .footer_icon.footer_icon_home {
    background-image: url(../../../src/assets/images/tab/shou.png);
}

.footer .footer_item .footer_icon.footer_icon_task {
    background-image: url(../../../src/assets/images/tab/item.png);
}

.footer .footer_item .footer_icon.footer_icon_cart {
    background-image: url(../../../src/assets/images/tab/kefu.png);
}

.footer .footer_item .footer_icon.footer_icon_user {
    background-image: url(../../../src/assets/images/tab/my.png);
}

.footer .footer_item .footer_info {
    font-size: 12px;
}

.footer .footer_item.footer_item_active {
    color: #3775f4;
}
</style> 